import styled from 'styled-components';

export const MENU_Y_OFFSET_PX = 8;

export const LocationAutocompleteWrapper = styled.div`
  flex-grow: 1;
`;
